export const API_BASE_URL = "https://your-api-url.com/";

const PREFIX = "/vi/api/v1.0";
export const GET_PROFILE = `${PREFIX}/User/profile`;
export const ACCOUNT_LOGIN = `${PREFIX}/User/login`;
export const SIGN_OUT = `${PREFIX}/User/logout`;
export const FORGOT_PASSWORD = `${PREFIX}/User/password/forgot-by-email`;
export const RESET_PASSWORD = `${PREFIX}/User/password/reset-by-email`;
export const SEARCH_BY_ROLES = `${PREFIX}/User/search-by-roles`;
export const REFRESH_TOKEN_API = `${PREFIX}/TokenManager/refresh-token`;
export const UPDATE_PROFILE = `${PREFIX}/User/profile`;
export const CHANGE_PASS_PROFILE = `${PREFIX}/User/change-pass-profile`;

// SSO API
const SSO_PREFIX = `${PREFIX}/KeycloakSsoAuth`;
export const SSO_LOGIN = `${SSO_PREFIX}/login`;
export const SSO_REFRESH_TOKEN = `${SSO_PREFIX}/refresh-token`;
export const SSO_LOGOUT = `${SSO_PREFIX}/logout`;

const SETTING_API = `${PREFIX}/Setting`;
export const SETTING_STORE_CATEGORY_API = `${SETTING_API}/store-categories`;
export const SETTING_MENU_CATEGORY_API = `${SETTING_API}/menu-categories`;
export const SETTING_STORE_UTILITY_API = `${SETTING_API}/store-utility`;
export const SETTING_PRODUCT_ATTRIBUTE = `${SETTING_API}/product-attribute-categories`;
export const SETTING_BANNER = `${SETTING_API}/banner`;
export const SETTING_TERM_CONDITION = `${SETTING_API}/system-setting/term-condition`;
export const SETTING_PRIVACY = `${SETTING_API}/system-setting/privacy`;

export const SETTING_MAPS_API = `${SETTING_API}/maps`;
export const GET_ALL_SETTING_MAPS = `${SETTING_MAPS_API}/all`;

export const TRIP_DELAY_API = `${SETTING_API}/trip-delay`;

export const SETTING_AUTH_API = `${SETTING_API}/auth`;
export const GET_ALL_SETTING_AUTH_API = `${SETTING_AUTH_API}/all`;

export const DRIVER_FINDING_RULE_API = `${SETTING_API}/driver-finding-rule`;

export const SETTING_VEHICLE_TYPE_API = `${SETTING_API}/vehicleType`;
export const GET_ALL_VEHICLE_TYPE_API = `${SETTING_VEHICLE_TYPE_API}/all`;

export const SETTING_ORDER_CANCEL_API = `${SETTING_API}/order-cancel`;
export const REFUND_ORDER_CANCEL_API = `${SETTING_ORDER_CANCEL_API}/refund`;
export const GET_ALL_CANCEL_ORDER_REFUND_API = `${REFUND_ORDER_CANCEL_API}/all`;

const LOCATION_API = `${PREFIX}/Location`;
export const GET_COUNTRY_API = `${LOCATION_API}/country`;
export const PROVINCE_BY_COUNTRY = `${LOCATION_API}/province-by-country`;
export const WARD_BY_PROVINCE = `${LOCATION_API}/ward-by-province`;
export const ALL_WARD = `${LOCATION_API}/wards`;
export const PRODUCT_API = `${PREFIX}/Product`;
export const PRODUCT_SEARCH_GRID = `${PRODUCT_API}/search-grid`;
export const PRODUCT_CHANGE_STATE = `${PRODUCT_API}/change-state`;
export const PRODUCTS_COPY = `${PRODUCT_API}/copy-product`;
export const PRODUCTS_GROUP_CATEGORY = `${PRODUCT_API}/group-category`;
export const PRODUCTS_CHANGE_STATUS = `${PRODUCT_API}/change-status`;
export const PRODUCTS_DISCOUNT = `${PRODUCT_API}/products-discount`;

const NOTIFICATION_API = `${PREFIX}/Notification`;
export const SEARCH_NOTIFICATION = `${NOTIFICATION_API}/search`;
export const READ_ALL_NOTIFICATION = `${NOTIFICATION_API}/read-all`;
export const DEL_ALL_NOTIFICATION = `${NOTIFICATION_API}/delete-all`;
export const SAVE_FIREBASE_TOKEN_NOTIFICATION = `${NOTIFICATION_API}/save-firebase-token`;
export const READ_NOTIFICATION = `${NOTIFICATION_API}/mark-read`;
export const SAVE_LABEL_STAR_NOTIFICATION = `${NOTIFICATION_API}/save-label-star`;
export const DEL_MULTI_NOTIFICATION = `${NOTIFICATION_API}/delete-multi`;

export const VOUCHER_API = `${PREFIX}/Voucher`;
export const VOUCHER_SEARCH_GRID = `${VOUCHER_API}/search-grid`;
export const VOUCHER_DETAIL_API = `${VOUCHER_API}/detail`;
export const VOUCHER_USAGE_SEARCH_GRID = `${VOUCHER_API}/search-grid-usage`;
export const VOUCHER_EXPORT_EXCEL = `${VOUCHER_API}/export-excel`;
export const VOUCHER_OVERVIEW_STATS = `${VOUCHER_API}/overview-stats`;
export const VOUCHER_DAILY_TREND_CHART = `${VOUCHER_API}/daily-trend-chart`;
export const VOUCHER_ROI_CHART = `${VOUCHER_API}/roi-chart`;
export const VOUCHER_LEADERBOARD = `${VOUCHER_API}/leaderboard`;

export const SETTING_SHIFT_API = `${PREFIX}/SettingShift`;
export const LIST_SHIFT_MONTHS_YEAR_API = `${SETTING_SHIFT_API}/list-shift-months-year`;
export const LIST_SHIFT_SEARCH_GRID_API = `${SETTING_SHIFT_API}/list-shift-search-grid`;
export const LIST_DROPDOWN_DRIVER = `${SETTING_SHIFT_API}/list-dropdown-driver`;
export const UPDATE_LIST_SHIFT_DRIVER = `${SETTING_SHIFT_API}/update-shift-driver`;
export const DRIVER_SHIFT_LIST_SEARCH_GRID = `${SETTING_SHIFT_API}/driver-shift-list-search-grid`;
export const COPY_SHIFT_DAY_API = `${SETTING_SHIFT_API}/copy-shift-day`;
export const COPY_SHIFT_MONTH_API = `${SETTING_SHIFT_API}/copy-shift-month`;
export const GET_ALL_SHIFT_API = `${SETTING_SHIFT_API}/all-shifts`;
export const UPDATE_SHIFT_API = `${SETTING_SHIFT_API}/update-shift`;

export const WARNING_API = `${PREFIX}/Warning`;
export const WARNING_SEARCH_GRID = `${WARNING_API}/search-grid`;
export const HANDLE_WARNING = `${WARNING_API}/warning-handle`;
export const HANDLE_WARNING_PINNED = `${WARNING_API}/pinned`;
export const HANDLE_WARNING_PROCESSING = `${WARNING_API}/processing`;
export const HANDLE_WARNING_MARK_RESOLVED = `${WARNING_API}/mark-resolved`;

export const SEARCH_WARNING_DETAIL = `${WARNING_API}/detail`;
export const MAP_SEARCH_API = `${PREFIX}/Monitor/search`;
export const MAP_WORKINGAREA_API = `${PREFIX}/Monitor/working-areas`;
export const SEARCH_PLACE_API = `${PREFIX}/Monitor/search-place`;
export const GET_PLACE_DETAIL_API = `${PREFIX}/Monitor/place-detail`;

// Order APIs
const ORDER_API = `${PREFIX}/Order`;
export const SEARCH_ORDER = `${ORDER_API}/search`;
export const GET_ORDER_DETAIL = `${ORDER_API}`;
export const GET_ORDER_TIMELINE = `${ORDER_API}/timeline`;
export const CREATE_ORDER = `${ORDER_API}/create`;
export const UPDATE_ORDER = `${ORDER_API}/update`;
export const CANCEL_ORDER = `${ORDER_API}/cancel`;
export const RECALCULATE_PRICE = `${ORDER_API}/recalculate-price`;
export const GET_CANCEL_PREVIEW = `${ORDER_API}/cancel-preview`;
export const EXPORT_EXCEL_ORDER = `${ORDER_API}/export-excel`;
export const ORDER_COUNT_BY_STATUS = `${ORDER_API}/count-by-status`;
export const ORDER_MARK_REFUND = `${ORDER_API}/mark-refunded`;
export const ORDER_PREVIEW_PRICE = `${ORDER_API}/preview-price`;

// Trip APIs
export const SEARCH_TRIP = `${ORDER_API}/trip/search`;
export const GET_TRIP_DETAIL = `${ORDER_API}/trip`;
export const TRIP_COUNT_BY_STATUS = `${ORDER_API}/trip/count-by-status`;

// OrderPayment APIs
const ORDER_PAYMENT_API = `${PREFIX}/OrderPayment`;
export const RECORD_PAYMENT = `${ORDER_PAYMENT_API}/record-payment`;
export const COMPLETE_TRIP = `${ORDER_PAYMENT_API}/complete-trip`;
export const GET_PAYMENT_SUMMARY = `${ORDER_PAYMENT_API}/summary`;
export const GET_PAYMENT_HISTORY = `${ORDER_PAYMENT_API}/history`;

const SURCHARGE_SLIP_API = `${PREFIX}/SurchargeSlip`;
export const GET_SURCHARGE_SLIP_BY_ORDER = `${SURCHARGE_SLIP_API}/by-order`;

export const CUSTOMER_API = `${PREFIX}/User`;
export const SEARCH_ORDER_CUSTOMER = `${ORDER_API}/search-order-customer`;

export const V2_CUSTOMER_API = `${PREFIX}/Customer`;
export const V2_GET_ALL_CUSTOMER_API = `${V2_CUSTOMER_API}/get-all`;
export const V2_CUSTOMER_SUMMARY_API = `${V2_CUSTOMER_API}/summary`;
export const V2_CUSTOMER_EXPORT_EXCEL = `${V2_CUSTOMER_API}/export-excel`;
export const V2_CUSTOMER_EXPORT_EXCEL_HISTORY = `${V2_CUSTOMER_API}/export-excel/order-history`;

export const EMPLOYEE_API = `${PREFIX}/User`;
export const EMPLOYEE_CREATE = `${EMPLOYEE_API}/create-user`;
export const EMPLOYEE_UPDATE = `${EMPLOYEE_API}/update-user`;
export const EMPLOYEE_CHANGE_STATUS = `${EMPLOYEE_API}/change-status`;
export const EMPLOYEE_CHANGE_PASSWORD = `${EMPLOYEE_API}/change-pass-employee`;
export const SEARCH_EMPLOYEE = `${EMPLOYEE_API}/search-grid-employee`;

export const DRIVER_API = `${PREFIX}/Driver`;
export const SUMMARY_DRIVER = `${DRIVER_API}/summary`;
export const GET_ALL_DRIVER = `${DRIVER_API}/get-all`;
export const CREATE_DRIVER = `${DRIVER_API}/create`;
export const UPDATE_DRIVER = `${DRIVER_API}/update`;
export const CHANGE_STATUS_DRIVER = `${DRIVER_API}/change-status`;
export const GET_ALL_ACTIVE_DRIVER = `${DRIVER_API}/active`;
export const GET_DRIVERS_VALID = `${DRIVER_API}/trip/drivers-valid`;
export const ASSIGN_DRIVER = `${DRIVER_API}/trip/assign-driver`;

export const MOBILE_DRIVER_API = `${PREFIX}/MobileDriver`;
export const MOBILE_DRIVER_REPORT = `${MOBILE_DRIVER_API}/monitoring`;
export const MOBILE_DRIVER_HISTORY_MONITORING = `${MOBILE_DRIVER_API}/monitoring/history`;

export const VEHICLE_API = `${PREFIX}/Vehicle`;
export const VEHICLE_SUMMARY = `${VEHICLE_API}/summary`;
export const GET_ALL_VEHICLE = `${VEHICLE_API}/get-all`;
export const CREATE_VEHICLE = `${VEHICLE_API}/create`;
export const UPDATE_VEHICLE = `${VEHICLE_API}/update`;
export const CHANGE_STATUS_VEHICLE = `${VEHICLE_API}/change-status`;

export const PRICE_SETTING_API = `${PREFIX}/PriceSetting`;
export const PRICE_SETTING_CREATE = `${PRICE_SETTING_API}/create-price`;
export const PRICE_SETTING_UPDATE = `${PRICE_SETTING_API}/update-price`;
export const SEARCH_PRICE_SETTING = `${PRICE_SETTING_API}/search-grid`;
export const PRICE_SETTING_CHANGE_STATUS = `${PRICE_SETTING_API}/change-status`;

export const REVIEW_API = `${PREFIX}/ReviewDriver`;
export const SEARCH_REVIEW = `${REVIEW_API}/search-grid`;
export const REVIEW_CREATE = `${REVIEW_API}/create-review`;

export const PLACE_API = `${PREFIX}/Place`;
export const SEARCH_PLACE = `${PLACE_API}/search-grid`;
export const PLACE_DETAIL_API = `${PLACE_API}/detail`;
export const PLACE_CHANGE_STATUS = `${PLACE_API}/change-status`;

export const DRIVER_FEEDBACK_API = `${PREFIX}/SettingDriverFeedback`;
export const DRIVER_FEEDBACK_GOOD = `${DRIVER_FEEDBACK_API}/get-all-good`;
export const DRIVER_FEEDBACK_BAD = `${DRIVER_FEEDBACK_API}/get-all-bad`;

const SYSTEM_SETTING_API = `${PREFIX}/SystemSetting`;
export const SAVE_SYSTEM_SETTING_API = `${SYSTEM_SETTING_API}/save-setting-system`;
export const SAVE_NOTIFY_TIME_API = `${SYSTEM_SETTING_API}/save-notify-time`;
export const GET_SYSTEM_SETTING_OTHER_API = `${SYSTEM_SETTING_API}/get-system-setting`;
export const GET_CANCEL_ORDER_REASON = `${SYSTEM_SETTING_API}/cancel-order-reason`;
export const GET_REJECT_ORDER_REASON = `${SYSTEM_SETTING_API}/reject-order-reason`;
export const GET_OFFLINE_REASON = `${SYSTEM_SETTING_API}/offline-reason`;
export const REASON_CREATE = `${SYSTEM_SETTING_API}/add-reason`;
export const REASON_UPDATE = `${SYSTEM_SETTING_API}/update-reason`;
export const REASON_DELETE = `${SYSTEM_SETTING_API}/delete-reason`;

const REPORT_API = `${PREFIX}/Report`;
export const REPORT_GET_REPORT_REVENUE = `${REPORT_API}/get-report-revenue`;
export const REPORT_GET_IMPORTANT_USER_CHART = `${REPORT_API}/get-important-user-chart`;

export const REPORT_ORDER = `${REPORT_API}/order`;
export const REPORT_ORDER_STATS = `${REPORT_ORDER}/stats`;
export const REPORT_ORDER_DAILY_REVENUE = `${REPORT_ORDER}/daily-revenue`;
export const REPORT_ORDER_DAILY_COUNT = `${REPORT_ORDER}/daily-count`;
export const REPORT_ORDER_REVENUE_BY_AIRPORT = `${REPORT_ORDER}/revenue-by-airport`;
export const REPORT_ORDER_DETAIL_BY_AIRPORT = `${REPORT_ORDER}/detail-by-airport`;
export const REPORT_ORDER_EXPORT = `${REPORT_ORDER}/export`;

export const REPORT_CUSTOMER = `${REPORT_API}/customer`;
export const REPORT_CUSTOMER_STATS = `${REPORT_CUSTOMER}/stats`;
export const REPORT_CUSTOMER_DAILY_NEW = `${REPORT_CUSTOMER}/daily-new`;
export const REPORT_CUSTOMER_RETENTION = `${REPORT_CUSTOMER}/retention`;
export const REPORT_CUSTOMER_TOP_SPENDING = `${REPORT_CUSTOMER}/top-spending`;
export const REPORT_CUSTOMER_EXPORT = `${REPORT_CUSTOMER}/export`;

export const REPORT_DRIVER_VEHICLE = `${REPORT_API}/driver-vehicle`;
export const REPORT_DRIVER_VEHICLE_STATS = `${REPORT_DRIVER_VEHICLE}/stats`;
export const REPORT_DRIVER_VEHICLE_TOP_DRIVERS = `${REPORT_DRIVER_VEHICLE}/top-drivers`;
export const REPORT_DRIVER_VEHICLE_TOP_VEHICLES = `${REPORT_DRIVER_VEHICLE}/top-vehicles`;
export const REPORT_DRIVER_VEHICLE_RANKING = `${REPORT_DRIVER_VEHICLE}/ranking`;
export const REPORT_DRIVER_EXPORT = `${REPORT_DRIVER_VEHICLE}/export`;

export const REPORT_VEHICLE_EXPENSE = `${REPORT_API}/vehicle-expense`;
export const REPORT_VEHICLE_EXPENSE_SUMMARY = `${REPORT_VEHICLE_EXPENSE}/summary`;
export const REPORT_VEHICLE_EXPENSE_PIE_CHART = `${REPORT_VEHICLE_EXPENSE}/pie-chart`;
export const REPORT_VEHICLE_EXPENSE_LINE_CHART = `${REPORT_VEHICLE_EXPENSE}/line-chart`;
export const REPORT_VEHICLE_EXPENSE_TABLE = `${REPORT_VEHICLE_EXPENSE}/table`;
export const REPORT_VEHICLE_EXPORT = `${REPORT_VEHICLE_EXPENSE}/export`;

export const REPORT_DASHBOARD = `${REPORT_API}/dashboard`;
export const REPORT_DASHBOARD_STATS = `${REPORT_DASHBOARD}/stats`;
export const REPORT_DASHBOARD_UNASSIGNED_TRIPS = `${REPORT_DASHBOARD}/unassigned-trips`;
export const REPORT_DASHBOARD_UPCOMING_TRIPS = `${REPORT_DASHBOARD}/upcoming-trips`;
export const REPORT_DASHBOARD_DRIVER_STATUS = `${REPORT_DASHBOARD}/driver-status`;
export const REPORT_DASHBOARD_ACTIVE_TRIPS = `${REPORT_DASHBOARD}/active-trips`;

export const WORKING_AREA_API = `${PREFIX}/WorkingArea`;
export const WORKING_AREA_SUMMARY = `${WORKING_AREA_API}/summary`;
export const GET_ALL_WORKING_AREA = `${WORKING_AREA_API}/GetAll`;
export const GET_ALL_ACTIVE_WORKING_AREA = `${WORKING_AREA_API}/active`;

export const LANGUAGE_API = `${PREFIX}/Language`;
export const LANGUAGE_GET_ALL = `${LANGUAGE_API}/get-all`;

export const ORDER_REASON_API = `${PREFIX}/CancelOrderReason`;
export const GET_ALL_REASON = `${ORDER_REASON_API}/get-all`;

export const COLLABORATOR_API = `${PREFIX}/Collaborator`;
export const COLLABORATOR_CREATE = `${COLLABORATOR_API}/create`;
export const COLLABORATOR_UPDATE = `${COLLABORATOR_API}/update`;
export const SEARCH_COLLABORATOR = `${COLLABORATOR_API}/search`;
export const COLLABORATOR_ALL_BANK = `${COLLABORATOR_API}/get-all-bank`;
export const COLLABORATOR_UPDATE_PAYMENT = `${COLLABORATOR_API}/update-payment`;
export const COLLABORATOR_DETAIL_API = `${COLLABORATOR_API}/detail`;
export const ORDER_COLLABORATOR = `${COLLABORATOR_API}/report-collaborator-order`;
export const TOP_COLLABORATOR = `${COLLABORATOR_API}/top-collaborator`;
export const REMOVE_ROLE_COLLABORATOR = `${COLLABORATOR_API}/remove-role`;
export const REPORT_COLLABORATOR = `${COLLABORATOR_API}/report-collaborator`;
export const CHECK_COLLABORATOR = `${COLLABORATOR_API}/check`;

export const COLLABORATOR_PAYMENT_API = `${PREFIX}/CollaboratorPayment`;
export const SEARCH_COLLABORATOR_PAYMENT = `${COLLABORATOR_PAYMENT_API}/search`;
export const COLLABORATOR_PAYMENT_CHANGE_STATUS = `${COLLABORATOR_PAYMENT_API}/change-status`;
export const COLLABORATOR_PAYMENT_UPDATE_MANY_STATUS = `${COLLABORATOR_PAYMENT_API}/update-many-status`;
export const COLLABORATOR_PAYMENT_DETAIL_API = `${COLLABORATOR_PAYMENT_API}/detail`;

export const COLLABORATOR_SETTING_API = `${PREFIX}/CollaboratorSetting`;
export const COLLABORATOR_SETTING_CREATE = `${COLLABORATOR_SETTING_API}/create`;
export const COLLABORATOR_SETTING_UPDATE = `${COLLABORATOR_SETTING_API}/update`;
export const GET_ALL_COLLABORATOR_SETTING = `${COLLABORATOR_SETTING_API}/get-all`;
export const COLLABORATOR_SETTING_SAVE = `${COLLABORATOR_SETTING_API}/save`;

export const SETTING_HIDE_ORDER_API = `${PREFIX}/SettingHideOrder`;
export const GET_ALL_SETTING_HIDE_ORDER = `${SETTING_HIDE_ORDER_API}/get-all`;
export const SETTING_HIDE_ORDER_SAVE = `${SETTING_HIDE_ORDER_API}/save`;

export const SETTING_SURCHARGE_CATEGORY_API = `${PREFIX}/SettingSurchargeCategory`;
export const GET_ALL_SETTING_SURCHARGE_CATEGORY = `${SETTING_SURCHARGE_CATEGORY_API}/all`;
export const SETTING_SURCHARGE_CATEGORY_UPDATE = `${SETTING_SURCHARGE_CATEGORY_API}/update`;

export const VEHICLE_EXPENSE_API = `${PREFIX}/VehicleExpense`;
export const VEHICLE_EXPENSE_CATEGORIES = `${VEHICLE_EXPENSE_API}/categories`;
export const VEHICLE_EXPENSE_GET_ALL = `${VEHICLE_EXPENSE_API}/get-all`;
export const VEHICLE_EXPENSE_SUMMARY = `${VEHICLE_EXPENSE_API}/summary`;
export const VEHICLE_EXPENSE_APPROVE = `${VEHICLE_EXPENSE_API}/approve`;
export const VEHICLE_EXPENSE_PAY = `${VEHICLE_EXPENSE_API}/pay`;
export const EXPORT_VEHICLE_EXPENSE = `${VEHICLE_EXPENSE_API}/export-excel`;

export const PRICING_API = `${PREFIX}/Pricing`;
export const DISTANCE_RATE_API = `${PRICING_API}/distance-rates`;
export const TIME_SURCHARGES_API = `${PRICING_API}/time-surcharges`;
export const TRIP_TYPES_API = `${PRICING_API}/trip-types`;
export const ADDON_SERVICES_API = `${PRICING_API}/addon-services`;
export const AIRPORT_FEES_API = `${PRICING_API}/airport-fees`;
export const HOLIDAY_SURCHARGE_API = `${PRICING_API}/holiday-surcharge`;
export const TOLL_ROUTES_API = `${PRICING_API}/toll-routes`;
export const ZONE_RATES_API = `${PRICING_API}/zone-rates`;
export const RADIUS_RATES_API = `${PRICING_API}/radius-rates`;
export const MINIMUM_PRICES_API = `${PRICING_API}/minimum-prices`;
export const PRICING_CALCULATE_API = `${PRICING_API}/calculate`;
export const VAT_SETTING_API = `${PRICING_API}/vat-setting`;

export const BANK_ACCOUNT_API = `${PREFIX}/BankAccount`;
export const GET_ALL_BANK_ACCOUNT = `${BANK_ACCOUNT_API}/get-all`;
export const GET_BANKS = `${BANK_ACCOUNT_API}/viet-qr/banks`;
export const CREATE_BANK_ACCOUNT_API = `${BANK_ACCOUNT_API}/create`;
export const UPDATE_BANK_ACCOUNT_API = `${BANK_ACCOUNT_API}/update`;
export const SET_DEFAULT_BANK_ACCOUNT_API = `${BANK_ACCOUNT_API}/set-default`;

export const AIRLINE_API = `${PREFIX}/Airline`;
export const GET_ALL_AIRLINE = `${AIRLINE_API}/get-all`;
export const GET_ALL_AIRLINE_ACTIVE = `${AIRLINE_API}/get-all-active`;
export const CREATE_AIRLINE = `${AIRLINE_API}/create`;
export const UPDATE_AIRLINE = `${AIRLINE_API}/update`;

export const PERMISSION_API = `${PREFIX}/Permission`;
export const GET_ALL_PERMISSION = `${PERMISSION_API}/get-all`;

export const ROLE_API = `${PREFIX}/Role`;
export const GET_ALL_ROLE = `${ROLE_API}/get-all`;
export const CREATE_ROLE = `${ROLE_API}/create`;
export const UPDATE_ROLE = `${ROLE_API}/update`;

export const DOCUMENT_CODE_API = `${PREFIX}/DocumentCode`;
export const DC_GET_CONFIGS = `${DOCUMENT_CODE_API}/get-configs`;
export const DC_SAVE_CONFIGS = `${DOCUMENT_CODE_API}/save-configs`;
export const DC_RESTORE_DEFAULTS = `${DOCUMENT_CODE_API}/restore-defaults`;
export const DC_PREVIEW = `${DOCUMENT_CODE_API}/preview`;

export const FLIGHT_ROUTE_API = `${PREFIX}/FlightRoute`;
export const GET_ALL_FLIGHT_ROUTE = `${FLIGHT_ROUTE_API}/get-all`;
export const GET_ALL_ACTIVE_FLIGHT_ROUTE = `${FLIGHT_ROUTE_API}/get-all-active`;
export const CREATE_FLIGHT_ROUTE = `${FLIGHT_ROUTE_API}/create`;
export const UPDATE_FLIGHT_ROUTE = `${FLIGHT_ROUTE_API}/update`;
